// Builds a full HTML document string from mini-site template data.
export function buildTemplateHtml(t = {}, opts = {}) {
  const d = {
    bg_color: "#EFF6FF",
    button_color: "#2563EB",
    text_color: "#0F172A",
    avatar: "",
    name: "",
    bio: "",
    verified: false,
    links: [],
    socials: [],
    background_image: "",
    ...t,
  };
  const safe = (s) => String(s == null ? "" : s);
  const bgStyle = d.background_image
    ? `background:linear-gradient(180deg, rgba(255,255,255,.65), rgba(255,255,255,.85)), url('${safe(d.background_image)}') center/cover fixed;`
    : `background:${safe(d.bg_color)};`;
  const linksHtml = (d.links || [])
    .filter((l) => l && l.label)
    .map(
      (l) =>
        `<a class="kl-btn" href="${safe(l.url) || "#"}" target="_blank" rel="noopener" style="background:${safe(
          d.button_color
        )}">${safe(l.label)}</a>`
    )
    .join("");
  const socialsHtml = (d.socials || [])
    .filter((s) => s && s.url)
    .map(
      (s) =>
        `<a class="kl-social" href="${safe(s.url)}" target="_blank" rel="noopener" title="${safe(
          s.platform
        )}">${safe((s.platform || "•").slice(0, 2)).toUpperCase()}</a>`
    )
    .join("");
  const verified = d.verified
    ? `<span style="display:inline-flex;width:18px;height:18px;background:#2563EB;color:#fff;border-radius:50%;align-items:center;justify-content:center;font-size:11px;margin-left:6px;">✓</span>`
    : "";
  const brand = opts.siteName || "kisalink.net";
  return `<!DOCTYPE html><html lang="tr"><head><meta charset="utf-8"/>
<meta name="viewport" content="width=device-width, initial-scale=1"/>
<style>
*{box-sizing:border-box;margin:0;padding:0;}
body{font-family:'Inter',system-ui,-apple-system,sans-serif;${bgStyle}min-height:100vh;display:flex;align-items:flex-start;justify-content:center;padding:48px 16px;color:${safe(
    d.text_color
  )};}
.wrap{width:100%;max-width:480px;text-align:center;}
.avatar{width:104px;height:104px;border-radius:50%;object-fit:cover;border:4px solid #fff;box-shadow:0 10px 30px rgba(2,6,23,.12);margin:0 auto 18px;background:#e2e8f0;}
h1{font-family:'Outfit',sans-serif;font-size:24px;font-weight:700;display:flex;align-items:center;justify-content:center;}
.bio{margin:10px 0 22px;color:#475569;font-size:15px;line-height:1.6;}
.kl-btn{display:block;width:100%;padding:15px 18px;border-radius:14px;color:#fff;font-weight:600;text-decoration:none;margin-bottom:12px;box-shadow:0 6px 18px rgba(37,99,235,.18);transition:transform .15s ease;}
.kl-btn:hover{transform:translateY(-2px);}
.socials{display:flex;gap:10px;justify-content:center;margin:6px 0 26px;flex-wrap:wrap;}
.kl-social{width:44px;height:44px;border-radius:12px;background:#fff;color:#2563EB;display:flex;align-items:center;justify-content:center;font-weight:700;text-decoration:none;box-shadow:0 4px 12px rgba(2,6,23,.08);font-size:13px;}
.footer{margin-top:30px;font-size:12px;color:#94a3b8;}
.footer a{color:#2563EB;text-decoration:none;font-weight:600;}
</style></head><body><div class="wrap">
${d.avatar ? `<img class="avatar" src="${safe(d.avatar)}" alt="${safe(d.name)}"/>` : `<div class="avatar"></div>`}
<h1>${safe(d.name) || "İsimsiz"}${verified}</h1>
${d.bio ? `<p class="bio">${safe(d.bio)}</p>` : ""}
${socialsHtml ? `<div class="socials">${socialsHtml}</div>` : ""}
${linksHtml}
<div class="footer">⚡ <a href="/" >${brand}</a> ile oluşturuldu</div>
</div></body></html>`;
}
